module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10473/images/person-with-box/person-with-box@1x.svg"